module.exports = __webpack_public_path__ + "img/redTheme.10f36867.png";